import CloseIcon from '@mui/icons-material/Close'
import { Box, Typography, useTheme } from '@mui/material'
import { WrapFlexBox } from '../../Boxes/WrapFlexBox'
import { PopupsBox, PopupsButton, PopupsClose, PopupsInside } from '../styles'
import { useAuth } from '../../../layouts/AuthContext'
interface IJoinUsProps {
  isJoinUsOpen: boolean
  closeJoinUs: () => void
  closePopups: () => void
}

export const JoinUs: React.FC<IJoinUsProps> = ({ isJoinUsOpen, closeJoinUs, closePopups }) => {
  const theme = useTheme()
  const { handleLogin } = useAuth()

  return (
    <div onClick={closePopups}>
      <PopupsInside className='PopupsOutside' display={isJoinUsOpen ? 'flex' : 'none'}>
        <PopupsBox>
          <PopupsClose onClick={closeJoinUs}>
            <CloseIcon fontSize='large' sx={{ '&:hover': { fill: '#fec40c' } }} />
          </PopupsClose>
          <WrapFlexBox>
            <Box>
              <Typography fontSize='30px' fontWeight='600' pb={theme.spacing(3)}>
                Welcome to Skill Rade
              </Typography>
              <Typography fontSize='24px' fontWeight='600' pb={theme.spacing(2)}>
                Join us with
              </Typography>
            </Box>
            <PopupsButton onClick={handleLogin}>
              <Box width={'60%'}>Sign in</Box>
            </PopupsButton>
          </WrapFlexBox>
        </PopupsBox>
      </PopupsInside>
    </div>
  )
}
